module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.80403756.eot";